import { render, staticRenderFns } from "./NotesTextField-V2.vue?vue&type=template&id=c7f20fb8"
import script from "./NotesTextField-V2.vue?vue&type=script&lang=js"
export * from "./NotesTextField-V2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports